/* Keep the service index before the document, compact on small screens. */
(() => {
  const panels = document.querySelectorAll('[data-bm-cms-nav]');
  if (!panels.length) return;
  const small = matchMedia('(max-width: 760px)');
  const adapt = () => panels.forEach(panel => { panel.open = !small.matches; });
  adapt();
  small.addEventListener('change', adapt);
})();
